import { React, useEffect, useState, useRef, useLayoutEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  PaymentElement,
  LinkAuthenticationElement,
  useStripe,
  useElements,
  AddressElement,
} from "@stripe/react-stripe-js";
import { setCartItems } from "../../store/actions"; // adjust the import path as needed
import { Link } from "react-router-dom";

const CheckoutForm = () => {
  const targetRef = useRef();
  const stripe = useStripe();
  const elements = useElements();
  const cartItems = useSelector((state) => state.cartItems);
  const dispatch = useDispatch();

  const [email, setEmail] = useState("");
  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const isMobile = screenWidth < 768;

  // Define a fixed shipping cost (you can adjust as needed)
  const shippingCost = 20;

  let subtotal = 0;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js hasn't yet loaded.
      return;
    }

    setIsLoading(true);

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        // Redirect to your payment completion page:
        return_url: process.env.REACT_APP_FRONTEND_ENDPOINT + "/payment",
      },
    });
    console.log({ error });

    if (error) {
      if (
        error.type === "card_error" ||
        error.type === "validation_error" ||
        error.type === "invalid_request_error"
      ) {
        setMessage(error.message);
      } else {
        setMessage("An unexpected error occurred.");
      }
    }
    setIsLoading(false);
  };

   useLayoutEffect(() => {
      if (targetRef.current) {
        setScreenWidth(window.innerWidth < 768);
      }
    }, []);

  useEffect(() => {
    if (!stripe) return;

    const clientSecret = new URLSearchParams(window.location.search).get(
      "payment_intent_client_secret"
    );
    if (!clientSecret) return;

    stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
      switch (paymentIntent.status) {
        case "succeeded":
          setMessage("Payment succeeded!");
          break;
        case "processing":
          setMessage("Your payment is processing.");
          break;
        case "requires_payment_method":
          setMessage("Your payment was not successful, please try again.");
          break;
        default:
          setMessage("Something went wrong.");
          break;
      }
    });
  }, [stripe]);

  const onChangeHandler = (e) => {
    console.log(e);
    setEmail(e.value);
  };

  // Function to handle quantity update
  const handlerProductQuantity = (product_id, mode) => {
    const updatedCart = cartItems.map((item) => {
      if (item.product_id === product_id) {
        let currentQuantity = item.product_quantity || 1;
        if (mode === "p") {
          currentQuantity++;
        } else {
          currentQuantity--;
        }
        currentQuantity = currentQuantity === 0 ? 1 : currentQuantity;
        return { ...item, product_quantity: currentQuantity };
      }
      return item;
    });
    dispatch(setCartItems(updatedCart));
  };

  // Function to remove item from cart
  const handlerRemove = (product_id) => {
    dispatch(setCartItems(cartItems.filter((item) => item.product_id !== product_id)));
  };
  let inputFieldClassName = "w-100px px-6 " + (isMobile ? "text-center" : "text-right");
  console.log("Ndriqim", inputFieldClassName);

  return (
    <main id="content">
      {/* Breadcrumb Section */}
      <section className="bg-color-3 mt-10">
          <div className="container">
            <nav
              aria-label="breadcrumb"
              className="d-flex align-items-center justify-content-between"
            >
              <ol className="breadcrumb py-3 mr-6">
                <li className="breadcrumb-item">
                  <Link to="/">Startseite</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/shop">Shop</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Kasse
                </li>
              </ol>
            </nav>
          </div>
        </section>

      {/* Checkout Form Section */}
      <section className="pb-11 pb-lg-15 pt-10">
        <div className="container">
          <h2 className="fs-sm-40 mb-9 text-center">Kasse</h2>
          <form onSubmit={handleSubmit}>
            {/* Row with two equal columns */}
            <div className="row">
              {/* Left Column (col-lg-6): Product Table */}
              <div className="col-lg-6 border-top">
              <div className="card border-0 mt-5">
                  <div className="card-header border-0 bg-transparent p-0">
                    <h4 className="card-title fs-24 mb-0">Produkte</h4>
                  </div>
                  </div>
                <div className="table-responsive">
                  <table className="table table-borderless">
                    <tbody>
                      {cartItems.map((item, index) => {
                        const quantity = item.product_quantity || 1;
                        const discount = item.product_discount || 0;
                        let price = discount
                          ? item.product_price - (item.product_price * discount) / 100
                          : item.product_price;
                        // Round to 2 decimals
                        price = Math.round(price * 100) / 100;
                        const itemTotal = quantity * price;
                        subtotal += itemTotal;

                        const cover_image_url =
                          "/media/" + item.product_slug + "/thumb" + item.cover_image;
                        return (
                          <tr key={index}>
                            <td className="pl-0 py-6 align-middle">
                              <a
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handlerRemove(item.product_id);
                                }}
                                className="d-block mr-4 clickable"
                              >
                                <i className="fal fa-times"></i>
                              </a>
                            </td>
                            <td className="py-6 pl-0">
                              <div className="media">
                                <div className="w-90px mr-4">
                                  <img src={cover_image_url} alt={item.product_name} />
                                </div>
                                <div className="media-body">
                                  <p className="text-muted fs-12 mb-0 text-uppercase letter-spacing-05 lh-1 mb-1 font-weight-500">
                                    {item.category || "Product"}
                                  </p>
                                  <a href="#" className="font-weight-bold mb-1 d-block">
                                    {item.product_name}
                                  </a>
                                  <p className="fs-15 text-primary d-block mb-0">
                                    {/* Additional details can go here */}
                                  </p>
                                </div>
                              </div>
                            </td>
                            <td className="pl-0 py-6">
                              <div className="input-group w-124px">
                                <a
                                  href="#"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handlerProductQuantity(item.product_id, "m");
                                  }}
                                  className="down position-absolute pos-fixed-left-center pl-2 clickable"
                                >
                                  <i className="far fa-minus"></i>
                                </a>
                                <input
                                  name="number[]"
                                  type="number"
                                  className = { inputFieldClassName }
                                  value={quantity}
                                  readOnly
                                  required
                                />
                                <a
                                  href="#"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handlerProductQuantity(item.product_id, "p");
                                  }}
                                  className="up position-absolute pos-fixed-right-center pl-2 clickable"
                                >
                                  <i className="far fa-plus"></i>
                                </a>
                              </div>
                            </td>
                            <td className="pl-0 py-6">
                              <p className="mb-0 ml-12 text-primary">
                                {quantity} x {price.toFixed(2)} EUR
                              </p>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Right Column (col-lg-6): Shipping Details + Summary */}
              <div className="col-lg-6 border-top">

                {/* Summary Card */}
                <div className="card border-0 mt-5">
                  <div className="card-header border-0 bg-transparent p-0">
                    <h4 className="card-title fs-24 mb-0">Zusammenfassung</h4>
                  </div>
                  <div className="card-body pt-6 px-0 pb-4">
                    <div className="d-flex align-items-center mb-1">
                      <span className="text-primary">Zwischensumme</span>
                      <span className="d-block ml-auto text-primary">
                        {subtotal.toFixed(2)} EUR
                      </span>
                    </div>
                    <div className="d-flex align-items-center">
                      <span className="text-primary">Versandkosten</span>
                      <span className="d-block ml-auto text-primary">
                        {shippingCost.toFixed(2)} EUR
                      </span>
                    </div>
                  </div>
                  <div className="card-footer pt-4 px-0 bg-transparent">
                    <div className="d-flex align-items-center font-weight-bold mb-7">
                      <span className="text-primary">Gesamtsumme</span>
                      <span className="d-block ml-auto text-primary">
                        {(subtotal + shippingCost).toFixed(2)} EUR
                      </span>
                    </div>
                    <button
                      className="btn btn-primary btn-block"
                      disabled={isLoading || !stripe || !elements}
                      id="submit"
                      type="submit"
                    >
                      {isLoading ? (
                        <div className="spinner" id="spinner"></div>
                      ) : (
                        "Check Out"
                      )}
                    </button>
                  </div>
                </div>
                {/* Shipping Details */}
                <div className="mt-5">
                  <h3 className="fs-24 mb-7">Details zum Versand</h3>
                  <div>
                    <LinkAuthenticationElement
                      id="link-authentication-element"
                      onChange={onChangeHandler}
                    />
                    <AddressElement
                      id="address-element"
                      options={{
                        mode: "shipping",
                        fields: {
                          phone: "always",
                        },
                      }}
                    />
                    <PaymentElement
                      options={{
                        layout: "tabs",
                        defaultValues: {
                          billingDetails: { address: { country: "DE" } },
                        },
                      }}
                    />
                    {message && <div id="payment-message">{message}</div>}
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </section>
    </main>
  );
};

export default CheckoutForm;